/*
 * General custom events that wanted to be tracked regardless of framework and design
 */

class StatisticsCustomEvents {
  constructor() {}
  setup() {
    if(!window.uioGa || !uioGa.ga4event) return;
   
    this.trackAudio();
    this.trackVideo();
  }

  trackAudio() {
    const stat = this;

    [...document.querySelectorAll('audio')].forEach(audio => {
      audio.onplaying = function() {
        stat.trackMedia("audio_start", {
          "video_percent": 0,
          "video_provider": "VRTXAudio",
          "video_title": null,
          "video_url": this.querySelector("source").getAttribute("src"),
          "video_duration": parseInt(audio.duration, 10),
          "video_current_time": parseInt(audio.currentTime, 10),
          "visible": 0
        });
      };
      audio.onended = function() {
        stat.trackMedia("audio_complete", {
          "video_percent": 100,
          "video_provider": "VRTXAudio",
          "video_title": null,
          "video_url": this.querySelector("source").getAttribute("src"),
          "video_duration": parseInt(audio.duration, 10),
          "video_current_time": parseInt(audio.currentTime, 10),
          "visible": 0
        });
      };
      var timeCheckTen = function() {
        if ((audio.currentTime * 100) / audio.duration > 10) {
          audio.removeEventListener('timeupdate', timeCheckTen);
          stat.trackMedia("audio_progress", {
            "video_percent": 10,
            "video_provider": "VRTXAudio",
            "video_title": null,
            "video_url": this.querySelector("source").getAttribute("src"),
            "video_duration": parseInt(audio.duration, 10),
            "video_current_time": parseInt(audio.currentTime, 10),
            "visible": 0
          });
        }
      };
      var timeCheckTwentyFive = function() {
        if ((audio.currentTime * 100) / audio.duration > 25) {
          audio.removeEventListener('timeupdate', timeCheckTwentyFive);
          stat.trackMedia("audio_progress", {
            "video_percent": 25,
            "video_provider": "VRTXAudio",
            "video_title": null,
            "video_url": this.querySelector("source").getAttribute("src"),
            "video_duration": parseInt(audio.duration, 10),
            "video_current_time": parseInt(audio.currentTime, 10),
            "visible": 0
          });
        }
      };
      var timeCheckFifty = function() {
        if ((audio.currentTime * 100) / audio.duration > 50) {
          audio.removeEventListener('timeupdate', timeCheckFifty);
          stat.trackMedia("audio_progress", {
            "video_percent": 50,
            "video_provider": "VRTXAudio",
            "video_title": null,
            "video_url": this.querySelector("source").getAttribute("src"),
            "video_duration": parseInt(audio.duration, 10),
            "video_current_time": parseInt(audio.currentTime, 10),
            "visible": 0
          });
        }
      };

      var timeCheckSeventyFive = function() {
        if ((audio.currentTime * 100) / audio.duration > 75) {
          audio.removeEventListener('timeupdate', timeCheckSeventyFive);
          stat.trackMedia("audio_progress", {
            "video_percent": 75,
            "video_provider": "VRTXAudio",
            "video_title": null,
            "video_url": this.querySelector("source").getAttribute("src"),
            "video_duration": parseInt(audio.duration, 10),
            "video_current_time": parseInt(audio.currentTime, 10),
            "visible": 0
          });
        }
      };
      audio.addEventListener('timeupdate', timeCheckTen);
      audio.addEventListener('timeupdate', timeCheckTwentyFive);
      audio.addEventListener('timeupdate', timeCheckFifty);
      audio.addEventListener('timeupdate', timeCheckSeventyFive);
    });
  }

  trackVideo() {
    window.addEventListener("message", (e) => {
      if(e.data && typeof e.data === "string" && e.origin === "https://vrtx.uio.no") {
        var message = JSON.parse(e.data);
        switch(message.msgName) {
          case "videoPlay":
            this.trackMedia("video_start", {
              "video_percent": 0,
              "video_provider": "VRTXVideoApp",
              "video_title": message.title,
              "video_url": message.href,
              "video_duration": message.duration,
              "video_current_time": message.currentTime,
              "visible": 1
            });
            break;
          case "videoStop":
            this.trackMedia("video_complete", {
              "video_percent": 100,
              "video_provider": "VRTXVideoApp",
              "video_title": message.title,
              "video_url": message.href,
              "video_duration": message.duration,
              "video_current_time": message.currentTime,
              "visible": 1
            });
            break;
          case "video10Percent":
            this.trackMedia("video_progress", {
              "video_percent": 10,
              "video_provider": "VRTXVideoApp",
              "video_title": message.title,
              "video_url": message.href,
              "video_duration": message.duration,
              "video_current_time": message.currentTime,
              "visible": 1
            });
            break;
          case "video25Percent":
            this.trackMedia("video_progress", {
              "video_percent": 25,
              "video_provider": "VRTXVideoApp",
              "video_title": message.title,
              "video_url": message.href,
              "video_duration": message.duration,
              "video_current_time": message.currentTime,
              "visible": 1
            });
            break;
          case "video50Percent":
            this.trackMedia("video_progress", {
              "video_percent": 50,
              "video_provider": "VRTXVideoApp",
              "video_title": message.title,
              "video_url": message.href,
              "video_duration": message.duration,
              "video_current_time": message.currentTime,
              "visible": 1
            });
            break;
          case "video75Percent":
            this.trackMedia("video_progress", {
              "video_percent": 75,
              "video_provider": "VRTXVideoApp",
              "video_title": message.title,
              "video_url": message.href,
              "video_duration": message.duration,
              "video_current_time": message.currentTime,
              "visible": 1
            });
            break;
          default:
            break;
        }
      }
    });
  }
  trackMedia(name, options) {
    this.trackCustomEvent(name, options);
  }
  trackCustomEvent(name, options) {
    uioGa.ga4event(name, options);
    if(typeof options !== "undefined") {
      console.log(options);
    }
  }
}
export default new StatisticsCustomEvents;